// Config.js

export default class {
    static ProductLangs = ["Eng", "Kor", "Jpn", "Chn", "Esp", "Fra"];
    static defaultLANG = 'Kor';
    
    //   static  Server = 'https://play.discplayer.co.kr:5443'; // dev : 5443 -> rel :  7443
    static Server = ''; // proxy use packagae.json
    static S3Server = 'https://s3.ap-northeast-2.amazonaws.com/playcode.world'; 
    //   static  Server = 'https://onioi.com:7000'

    static fetchData(address, params, callback, revalidate = false, cbError) {

        var chcheoption = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        if (revalidate) {
            // chcheoption['Cache-Control'] = 'must-revalidate';
        }

        fetch(`${this.Server}/${address}`, {
            // mode: 'no-cors',
            method: 'POST',
            headers: chcheoption,
            body: JSON.stringify(params)
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson);
                if (callback)
                    callback(responseJson.result, responseJson.count);
            })
            .catch((error) => {
                console.error(error);
                if (cbError)
                    cbError(error);
            });
    }

}



// WEBPACK FOOTER //
// src/Config.js